import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import _ from 'underscore';
import Immutable from 'immutable';
import Textarea from 'views/ui/form_elements/textarea';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import MessageActionCreator from 'action_creators/message';
import ModalActionCreator from 'action_creators/modal';
import FormController from 'lib/form/controller';
import Dimmer from 'views/shared/ui/dimmer';
import { FormattedMessage, injectIntl } from 'react-intl';
import validations from './validations';
import './index.scss';

const MessageGuide = createReactClass({
  displayName: 'Confirmation-MessageGuide-Plugins',

  mixins: [StoreInterestMixin, FormController, PureRenderMixin],

  propTypes: {
    email: PropTypes.string.isRequired,
    guide_full_name: PropTypes.string.isRequired,
    recipient_id: PropTypes.number.isRequired,
    sender_id: PropTypes.number.isRequired,
    booking_id: PropTypes.number.isRequired,
  },

  getInitialState() {
    return {
      fields: Immutable.Map({
        recipient_id: this.props.recipient_id,
        sender_id: this.props.sender_id,
        booking_id: this.props.booking_id,
        message: this.props.message,
        origin_location: 'guest_checkout',
      }),
      messageSent: false,
      loading: false,
      errors: Immutable.Map({}),
    };
  },

  getStoreInterests() {
    return {
      loading: 'message.sending',
      errors: 'message.sendingErrors',
    };
  },

  validationConstraints() {
    return validations;
  },

  formSubmitted(params) {
    const self = this;
    MessageActionCreator.sendMessage(params, function () {
      self.setState({ messageSent: true });
    });
  },

  hideModal() {
    ModalActionCreator.hide();
  },

  _renderForm() {
    return (
      <div className="Confirmation-MessageGuide-Form dimmable">
        <Dimmer loader={this.state.loading} active={this.state.loading} fixed />
        <h3>
          <span
            className="Confirmation-MessageGuide-GuideName"
            id="send-message"
          >
            <strong>
              <FormattedMessage
                id="SEND_A_MESSAGE_TO"
                defaultMessage="Send a message to"
              />
            </strong>
            <br />
            <span className="normal-weight">{this.props.guide_full_name}</span>
          </span>
        </h3>
        <div className="Confirmation-MessageGuide-Textarea">
          <Textarea
            {..._.extend(this._formProps('message'), {
              placeholder: `${this.props.intl.formatMessage({ id: 'ENTER_YOUR_MESSAGE_HERE', defaultMessage: 'Enter your message here' })}...`,
            })}
            onChange={this.onChange}
            ariaLabelledBy="send-message"
          />
        </div>
        <div className="Confirmation-MessageGuide-Notes">
          <p>
            <FormattedMessage id="FROM_ALT" defaultMessage="From" />{' '}
            <span className="alt">{this.props.email}</span>
          </p>
        </div>
        <div className="Confirmation-MessageGuide-SubmitButton">
          <div
            className="ui button brand-bg"
            onClick={this.onSubmit}
            data-testid="send-message-button"
          >
            <FormattedMessage id="SEND_MESSAGE" defaultMessage="Send Message" />
          </div>
        </div>
      </div>
    );
  },

  _renderSuccessMessage() {
    return (
      <div className="Confirmation-MessageGuide-SuccessMessage">
        <h3 data-testid="send-meesage-success">
          <FormattedMessage id="MESSAGE_SENT" defaultMessage="Message sent" />!
        </h3>
        <div className="Confirmation-MessageGuide-Notes">
          <FormattedMessage
            id="confirmation.messageGuide.successNote"
            defaultMessage="You will hear from {name} shortly. {br}The responses will go to your email <alt>{email}</alt>."
            values={{
              name: this.props.guide_full_name,
              email: this.props.email,
              br: <br />,
              alt: (chunks) => <span className="alt">{chunks}</span>,
            }}
          />
        </div>
        <div className="Confirmation-MessageGuide-SubmitButton">
          <div
            className="ui button brand-bg"
            onClick={this.hideModal}
            data-testid="hide-success-modal"
          >
            <FormattedMessage id="OKAY" defaultMessage="Okay" />
          </div>
        </div>
      </div>
    );
  },

  render() {
    return (
      <div className="Confirmation-MessageGuide">
        <div className="Confirmation-MessageGuide-Content">
          {!this.state.messageSent
            ? this._renderForm()
            : this._renderSuccessMessage()}
        </div>
      </div>
    );
  },
});

export default injectIntl(MessageGuide);
